export interface DiscoveryStep {
    id: string;
    targetId: string;
    title: string;
    description: {
        normal: string;
        tech: string;
    };
    position: 'top' | 'bottom' | 'left' | 'right' | 'center' | 'top-right' | 'top-left';
    route?: string; // Optional route to navigate to before showing this step
    tabTriggerId?: string; // Optional element to click (e.g. a tab) before showing this step
}

export const DISCOVERY_STEPS: DiscoveryStep[] = [
    // --- WELCOME ---
    {
        id: 'welcome',
        targetId: 'interaction-hub',
        title: 'Welcome Aboard!',
        description: {
            normal: "Congratulations on taking the first step to becoming fitter, healthier, and faster. I'm your Coach, and I'll be here to guide you through your training hub. Currently, you are in 'Normal' mode—friendly and clear.",
            tech: "System initialized. Your performance environment is now active. You are currently in 'Tech' mode, providing high-fidelity metrics and deep physiological insights by default.",
        },
        position: 'center',
    },

    // --- DASHBOARD ---
    {
        id: 'dashboard',
        targetId: 'nav-item-/dashboard',
        title: 'Master Dashboard',
        route: '/dashboard',
        description: {
            normal: "Welcome to your control center. Here we summarize everything you need to do today to stay on track.",
            tech: "Primary performance cockpit. This view orchestrates your real-time data streams into actionable training load targets.",
        },
        position: 'right',
    },
    {
        id: 'today-workout',
        targetId: 'today-workout-card',
        title: 'Today\'s Mission',
        route: '/dashboard',
        description: {
            normal: "Your specific workout instructions. Tap for details on how to execute this session perfectly.",
            tech: "Daily prescription. High-definition interval blocks designed to trigger specific physiological adaptations.",
        },
        position: 'top',
    },
    {
        id: 'connect-intervals',
        targetId: 'intervals-connect-card',
        title: 'Connect Intervals.icu',
        route: '/dashboard',
        description: {
            normal: 'When you are ready, connect Intervals.icu to send planned workouts to your calendar so Garmin, Wahoo, Zwift and other devices can pick them up. Your completed training comes back here so the plan can adapt with better context.',
            tech: 'OAuth links Adaptive Endurance to Intervals.icu for workout calendar writeback plus activity, fitness and form ingestion. Intervals.icu handles the device ecosystem while this app focuses on adaptation logic.',
        },
        position: 'top',
    },
    {
        id: 'upcoming-workouts',
        targetId: 'upcoming-workouts',
        title: 'Near Horizon',
        route: '/dashboard',
        description: {
            normal: "A quick look at your next few days. Perfect for planning your week ahead.",
            tech: "Micro-cycle sequence. Visualization of the immediate loading pattern and upcoming stimulus.",
        },
        position: 'right',
    },

    // --- SCHEDULE ---
    {
        id: 'schedule',
        targetId: 'nav-item-/schedule',
        title: 'Training Schedule',
        route: '/schedule',
        description: {
            normal: "Your long-term road map. You can see every workout planned between now and your goal race.",
            tech: "Periodization Calendar. A structural view of your Base, Build, and Taper phases leading to peak performance.",
        },
        position: 'right',
    },
    {
        id: 'print-plan',
        targetId: 'print-plan-button',
        title: 'Physical Companion',
        route: '/schedule',
        description: {
            normal: "Old school but effective! Print your plan and stick it on your fridge to stay motivated.",
            tech: "Tactical Export. High-fidelity PDF output for analog tracking or manual performance journaling.",
        },
        position: 'bottom',
    },

    // --- SUPPORT / FEEDBACK ---
    {
        id: 'support-hub',
        targetId: 'interaction-hub',
        title: 'Need Help? We\'re Here!',
        route: '/dashboard',
        description: {
            normal: "This is your lifeline. Tap this button anytime you have questions, need support, or want to share feedback. You can also restart this guide from here.",
            tech: "Interaction Hub. Access the Discovery Guide, submit structured feedback, and reach the support team directly from this persistent widget.",
        },
        position: 'top-left',
    },
];
